export default __webpack_public_path__ + "static/media/120_sporofungus.f20babc9.png";